import { render } from "./loginToken.vue?vue&type=template&id=5195ebfd"
import script from "./loginToken.vue?vue&type=script&lang=js"
export * from "./loginToken.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__